"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNotNullAndNotEmpty = exports.hasRequiredLength = exports.anonymizedPiiContextGenerator = exports.anonymizedPiiContextFilter = void 0;
const SP_ZIP_CODE_LENGTH = 5;
function hasRequiredLength(value, requiredLength) {
    return value != null && value.length === requiredLength;
}
exports.hasRequiredLength = hasRequiredLength;
function isNotNullAndNotEmpty(value) {
    return value != null && value.length > 0;
}
exports.isNotNullAndNotEmpty = isNotNullAndNotEmpty;
function anonymizedPiiContextFilter(dataProvider) {
    return () => {
        const data = dataProvider.readPiiContextData();
        // Validate that at least one PII property is provided.
        const validFields = [];
        if (isNotNullAndNotEmpty(data.dob)) {
            validFields.push(data.dob);
        }
        if (isNotNullAndNotEmpty(data.email)) {
            validFields.push(data.email);
        }
        if (data.gender && data.gender.length > 0) {
            validFields.push(data.gender);
        }
        if (isNotNullAndNotEmpty(data.phoneNumber)) {
            validFields.push(data.phoneNumber);
        }
        if (hasRequiredLength(data.zipCode, SP_ZIP_CODE_LENGTH)) {
            validFields.push(data.zipCode);
        }
        return validFields.length > 0;
    };
}
exports.anonymizedPiiContextFilter = anonymizedPiiContextFilter;
function anonymizedPiiContextGenerator(dataProvider) {
    return () => {
        const data = dataProvider.readPiiContextData();
        return {
            schema: 'iglu:com.healthcare/ctx_anonymized_pii/jsonschema/1-0-1',
            data: {
                email: data.email,
                phone_number: data.phoneNumber,
                dob: data.dob,
                gender: data.gender,
                zip_code: data.zipCode,
            },
        };
    };
}
exports.anonymizedPiiContextGenerator = anonymizedPiiContextGenerator;
//# sourceMappingURL=context-generators.js.map